export const CHANGE_LOGIN_STATUS = 'CHANGE_LOGIN_STATS';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_GROUP = 'SET_USER_GROUP';